import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bmwicon_传送",
  "use": "icon-bmwicon_传送-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" id=\"icon-bmwicon_传送\"><path d=\"M17.16,37.56,22,30.89l-4.87-1.4v8.07ZM-.06,21.88l13.85,4.19L30.85,11.59,17.63,27.19l14.81,4.57L40.06,2.44-.06,21.88Z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol